module.exports = __webpack_public_path__ + "static/homepage_hero4-c2c6ccfcb41a7ea303fb72465e157e99.png";